import { render } from "./AdminUserSettings.vue?vue&type=template&id=21f341a7&scoped=true"
import script from "./AdminUserSettings.vue?vue&type=script&lang=js"
export * from "./AdminUserSettings.vue?vue&type=script&lang=js"

import "./AdminUserSettings.vue?vue&type=style&index=0&id=21f341a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f341a7"]])

export default __exports__